// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.acceptance.LeaseDisclaimerAcceptanceFromOuidWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { GetAttachedLeaseAcceptanceFromOuidResponseDto, GetDisclaimerAcceptanceFromOuidResponseDto } from '../..';

interface GetAttachedLeaseAcceptanceForUserFromOuidParams {
  ouid: string;
}
interface GetDisclaimerAcceptanceForUserFromOuidParams {
  ouid: string;
}
interface SetAttachedLeaseAcceptanceForUserFromOuidParams {
  ouid: string;
}
interface SetDisclaimerAcceptanceForUserFromOuidParams {
  ouid: string;
}

export const LeaseDisclaimerAcceptanceFromOuidWebApiHandler_getAttachedLeaseAcceptanceForUserFromOuid_Path =
  '/api/web/v1/ouid/getAttachedLeaseAcceptanceForUserFromOuid';

/**
 * get attached lease acceptance status for leasing user from ouid
 */
export const LeaseDisclaimerAcceptanceFromOuidWebApiHandler_getAttachedLeaseAcceptanceForUserFromOuid = (
  getParams: GetAttachedLeaseAcceptanceForUserFromOuidParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    GetAttachedLeaseAcceptanceForUserFromOuidParams,
    never,
    GetAttachedLeaseAcceptanceFromOuidResponseDto
  >(
    {
      getParams: getParams,
      endpoint: LeaseDisclaimerAcceptanceFromOuidWebApiHandler_getAttachedLeaseAcceptanceForUserFromOuid_Path,
      method: 'GET',
      contextPath: '/leasing',
    },
    client,
  );
};

export const LeaseDisclaimerAcceptanceFromOuidWebApiHandler_getDisclaimerAcceptanceForUserFromOuid_Path =
  '/api/web/v1/ouid/getDisclaimerAcceptanceForUserFromOuid';

/**
 * get disclaimer acceptance status for leasing user from ouid
 */
export const LeaseDisclaimerAcceptanceFromOuidWebApiHandler_getDisclaimerAcceptanceForUserFromOuid = (
  getParams: GetDisclaimerAcceptanceForUserFromOuidParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    GetDisclaimerAcceptanceForUserFromOuidParams,
    never,
    GetDisclaimerAcceptanceFromOuidResponseDto
  >(
    {
      getParams: getParams,
      endpoint: LeaseDisclaimerAcceptanceFromOuidWebApiHandler_getDisclaimerAcceptanceForUserFromOuid_Path,
      method: 'GET',
      contextPath: '/leasing',
    },
    client,
  );
};

export const LeaseDisclaimerAcceptanceFromOuidWebApiHandler_setAttachedLeaseAcceptanceForUserFromOuid_Path =
  '/api/web/v1/ouid/setAttachedLeaseAcceptanceForUserFromOuid';

/**
 * set attached lease acceptance for leasing user from ouid
 */
export const LeaseDisclaimerAcceptanceFromOuidWebApiHandler_setAttachedLeaseAcceptanceForUserFromOuid = (
  getParams: SetAttachedLeaseAcceptanceForUserFromOuidParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<SetAttachedLeaseAcceptanceForUserFromOuidParams, never, void>(
    {
      getParams: getParams,
      endpoint: LeaseDisclaimerAcceptanceFromOuidWebApiHandler_setAttachedLeaseAcceptanceForUserFromOuid_Path,
      method: 'POST',
      contextPath: '/leasing',
    },
    client,
  );
};

export const LeaseDisclaimerAcceptanceFromOuidWebApiHandler_setDisclaimerAcceptanceForUserFromOuid_Path =
  '/api/web/v1/ouid/setDisclaimerAcceptanceForUserFromOuid';

/**
 * set disclaimer acceptance for leasing user from ouid
 */
export const LeaseDisclaimerAcceptanceFromOuidWebApiHandler_setDisclaimerAcceptanceForUserFromOuid = (
  getParams: SetDisclaimerAcceptanceForUserFromOuidParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<SetDisclaimerAcceptanceForUserFromOuidParams, never, void>(
    {
      getParams: getParams,
      endpoint: LeaseDisclaimerAcceptanceFromOuidWebApiHandler_setDisclaimerAcceptanceForUserFromOuid_Path,
      method: 'POST',
      contextPath: '/leasing',
    },
    client,
  );
};
